import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "o-ico c-overlay__notebook__tools__link__icon"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=2024#arrow-left" })
], -1 /* HOISTED */)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-sm" }, null, -1 /* HOISTED */)
const _hoisted_3 = { class: "o-flex -flex-direction-column -flex-middle -flex-grow-1 -flex-overflow-auto -flex-width-100p" }
const _hoisted_4 = { class: "o-form -form-dark" }
const _hoisted_5 = { class: "o-flex -flex-direction-column" }
const _hoisted_6 = { class: "o-form__group" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "o-label sr-only"
}, " Courriel ", -1 /* HOISTED */)
const _hoisted_8 = { class: "o-form__group" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "pass",
  class: "o-label sr-only"
}, " Mot de passe ", -1 /* HOISTED */)
const _hoisted_10 = {
  key: 0,
  class: "o-alert -alert-error"
}
const _hoisted_11 = { class: "o-flex -flex-space-between -flex-middle" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer" }, null, -1 /* HOISTED */)
const _hoisted_13 = { class: "o-flex -flex-center" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.$emit('toggleView', 'cart')), ["prevent"])),
      class: "c-overlay__notebook__tools__link"
    }, [
      _hoisted_1,
      _createTextVNode(" Retour ")
    ]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              class: "o-input",
              type: "email",
              id: "email",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.username) = $event)),
              placeholder: "Courriel",
              required: ""
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $data.username]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              class: "o-input",
              type: "password",
              id: "pass",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.password) = $event)),
              placeholder: "Mot de passe",
              required: ""
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $data.password]
            ])
          ]),
          ($data.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($data.error), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              class: "c-overlay__notebook__button__register",
              onClick: _cache[3] || (_cache[3] = _withModifiers($event => (_ctx.$emit('toggleView', 'register')), ["prevent"]))
            }, "S'inscrire"),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = _withModifiers($event => ($options.login()), ["prevent"])),
              class: "c-overlay__notebook__button__login"
            }, " Connexion ")
          ])
        ]),
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            class: "c-overlay__notebook__button__password",
            onClick: _cache[5] || (_cache[5] = _withModifiers($event => (_ctx.$emit('toggleView', 'forgot')), ["prevent"]))
          }, " Mot de passe oublié ")
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}